import { success } from "toastr";
import * as types from "./actionTypes";

const initialState = {
  employeeSalaryDefinition: '',
  employeeSalaryIncrement: '',
  loantype: '',
  loannumber: '',
  installments: '',
  employeeloans: '',
  installment_list: '',
  finacial_types: '',
  employeeSalaryIncrementSavedCTC: '',
  saveIncrementSuccess: false,
  employeeIncrementApprovalCTC: '',
  employeeIncrementReport: '',
  employeefreezelist: '',
  employeepreclose: '',
  employeeloannumber: '',
  employeeloanapplists: '',
  emp_salaryinfo: '',
  emp_negsalaryinfo: '',
  salarygenerate: '',
  salarycale: '',
  salarygeneratelogs: '',
  saveSuccess: false,
  loading: false,
  error: null,
  success: false,
  saveLoading: false,
  successdata: [],
};

const payrollSalaryEmployeeSalaryDefinitionReducer = (state = initialState, action) => {

  switch (action.type) {
    case types.FETCH_EMPLOYEE_SALARY_DEFINITION:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_SALARY_DEFINITION_SUCCESS:
      return { ...state, loading: false, success: true, employeeSalaryDefinition: action.payload.data };
    case types.FETCH_EMPLOYEE_SALARY_DEFINITION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.FETCH_EMPLOYEE_SALARY_DEFINITION_CLEAR:
      return { ...state, loading: false, success: true, employeeSalaryDefinition: '' };
    case types.SAVE_EMPLOYEE_SALARY_DEFINITION:
      return { ...state, loading: true, success: false, error: null };
    case types.SAVE_EMPLOYEE_SALARY_DEFINITION_SUCCESS:
      return { ...state, loading: false, success: false, error: null };
    case types.SAVE_EMPLOYEE_SALARY_DEFINITION_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    case types.FETCH_EMPLOYEE_SALARY_INCREMENT:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_SALARY_INCREMENT_SUCCESS:
      return { ...state, loading: false, success: true, employeeSalaryIncrement: action.payload.data };
    case types.FETCH_EMPLOYEE_SALARY_INCREMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_FINANCIAL_INCREMENT_TYPES:
      return { ...state, loading: true, success: false };
    case types.FETCH_FINANCIAL_INCREMENT_TYPES_SUCCESS:
      return { ...state, loading: false, success: true, finacial_types: action.payload.data };
    case types.FETCH_FINANCIAL_INCREMENT_TYPES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_LOAN_TYPES:
      return { ...state, loading: true, success: false };
    case types.FETCH_LOAN_TYPES_SUCCESS:
      return { ...state, loading: false, success: true, loantype: action.payload.data };
    case types.FETCH_LOAN_TYPES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_LOAN_LOANNUMBER:
      return { ...state, loading: true, success: false };
    case types.FETCH_LOAN_LOANNUMBER_SUCCESS:
      return { ...state, loading: false, success: true, loannumber: action.payload.data };
    case types.FETCH_LOAN_LOANNUMBER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_LOAN_MONTHLY_INSTALLMENTS:
      return { ...state, loading: true, success: false };
    case types.FETCH_LOAN_MONTHLY_INSTALLMENTS_SUCCESS:
      return { ...state, loading: false, success: true, installments: action.payload.data };
    case types.FETCH_LOAN_MONTHLY_INSTALLMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.SAVE_LOAN_MONTHLY_INSTALLMENTS:
      return { ...state, loading: true, success: false };
    case types.SAVE_LOAN_MONTHLY_INSTALLMENTS_SUCCESS:
      return { ...state, loading: false, success: true, saveSuccess: true };
    case types.SAVE_LOAN_MONTHLY_INSTALLMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.RESET_SAVE_STATUS:
      return {
        ...state,
        employeeSalaryDefinition: [],
        employeeSalaryIncrement: [],
        loantype: [],
        loannumber: [],
        installments: [],
        employeeloans: [],
        installment_list: [],
        finacial_types: [],
        employeeSalaryIncrementSavedCTC: [],
        saveIncrementSuccess: false,
        employeeIncrementApprovalCTC: [],
        employeeIncrementReport: [],
        employeefreezelist: [],
        employeepreclose: [],
        employeeloannumber: [],
        employeeloanapplists: [],
        emp_salaryinfo: [],
        emp_negsalaryinfo: [],
        salarygenerate: [],
        salarycale: [],
        // salarygeneratelogs: [],
        saveSuccess: false,
      };

    case types.FETCH_EMPLOYEE_LOAN_LISTS:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_LOAN_LISTS_SUCCESS:
      return { ...state, loading: false, success: true, employeeloans: action.payload.data };
    case types.FETCH_EMPLOYEE_LOAN_LISTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_EMPLOYEE_LOAN_INSTALLMENTS:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_LOAN_INSTALLMENTS_SUCCESS:
      return { ...state, loading: false, success: true, installment_list: action.payload.data };
    case types.FETCH_EMPLOYEE_LOAN_INSTALLMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.SAVE_EMPLOYEE_SALARY_INCREMENT_CTC:
      return { ...state, loading: true, success: false };
    case types.SAVE_EMPLOYEE_SALARY_INCREMENT_CTC_SUCCESS:
      return { ...state, loading: false, success: true, saveIncrementSuccess: true, };
    case types.SAVE_EMPLOYEE_SALARY_INCREMENT_CTC_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC_SUCCESS:
      return { ...state, loading: false, success: true, employeeSalaryIncrementSavedCTC: action.payload || [] };
    case types.FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.RESET_SAVE_INCREMENT_STATUS:
      return { ...state, saveIncrementSuccess: false, };

    case types.FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC_SUCCESS:
      return { ...state, loading: false, success: true, employeeIncrementApprovalCTC: action.payload || [] };
    case types.FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC:
      return { ...state, loading: true, success: false };
    case types.SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC_SUCCESS:
      return { ...state, loading: false, success: true, successdata: action.payload, saveIncrementSuccess: true, };
    case types.SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_EMPLOYEE_INCREMENT_REPORT:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_INCREMENT_REPORT_SUCCESS:
      return { ...state, loading: false, success: true, employeeIncrementReport: action.payload };
    case types.FETCH_EMPLOYEE_INCREMENT_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_EMPLOYEE_LOAN_NO_PRECLOSE:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_LOAN_NO_PRECLOSE_SUCCESS:
      return { ...state, loading: false, success: true, employeeloannumber: action.payload };
    case types.FETCH_EMPLOYEE_LOAN_NO_PRECLOSE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_EMPLOYEE_PRECLOSE:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_PRECLOSE_SUCCESS:
      return { ...state, loading: false, success: true, employeepreclose: action.payload };
    case types.FETCH_EMPLOYEE_PRECLOSE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.SAVE_LOAN_PRECLOSE:
      return { ...state, loading: true, success: false };
    case types.SAVE_LOAN_PRECLOSE_SUCCESS:
      return { ...state, loading: false, success: true, saveSuccess: true };
    case types.SAVE_LOAN_PRECLOSE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.SAVE_EMPLOYEE_LOAN_FREEZE:
      return { ...state, loading: true, success: false };
    case types.SAVE_EMPLOYEE_LOAN_FREEZE_SUCCESS:
      return { ...state, loading: false, success: true, saveSuccess: true };
    case types.SAVE_EMPLOYEE_LOAN_FREEZE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_EMPLOYEE_LOAN_FREEZE:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_LOAN_FREEZE_SUCCESS:
      return { ...state, loading: false, success: true, employeefreezelist: action.payload };
    case types.FETCH_EMPLOYEE_LOAN_FREEZE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_EMPLOYEE_LOAN_APPOVAL:
      return { ...state, loading: true, success: false };
    case types.FETCH_EMPLOYEE_LOAN_APPOVAL_SUCCESS:
      return { ...state, loading: false, success: true, employeeloanapplists: action.payload || [] };
    case types.FETCH_EMPLOYEE_LOAN_APPOVAL_FAILURE:
      return { ...state, loading: false, error: action.payload, employeeloanapplists: [], };

    case types.SAVE_EMPLOYEE_LOAN_APPOVALS:
      return { ...state, loading: true, success: false };
    case types.SAVE_EMPLOYEE_LOAN_APPOVALS_SUCCESS:
      return { ...state, loading: false, success: true, saveSuccess: true };
    case types.SAVE_EMPLOYEE_LOAN_APPOVALS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_SALARY_GEN_SCALE:
      return { ...state, loading: true, success: false };
    case types.FETCH_SALARY_GEN_SCALE_SUCCESS:
      return { ...state, loading: false, success: true, salarycale: action.payload };
    case types.FETCH_SALARY_GEN_SCALE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.SAVE_SALARY_GENERATION:
      return { ...state, loading: true, success: false };
    case types.SAVE_SALARY_GENERATION_SUCCESS:
      return { ...state, loading: false, success: true, salarygenerate: action.payload };
    case types.SAVE_SALARY_GENERATION_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.SAVE_SALARY_GENERATION:
      return { ...state, loading: true, success: false, saveLoading: true };
    case types.SAVE_SALARY_GENERATION_SUCCESS:
      return { ...state, loading: false, success: true, salarygenerate: action.payload, saveLoading: false };
    case types.SAVE_SALARY_GENERATION_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false, saveLoading: false };

    case types.SAVE_SALARY_GENERATION_LEAVE_APPROVALS:
      return { ...state, loading: true, success: false };
    case types.SAVE_SALARY_GENERATION_LEAVE_APPROVALS_SUCCESS:
      return { ...state, loading: false, success: true, saveSuccess: true };
    case types.SAVE_SALARY_GENERATION_LEAVE_APPROVALS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.SAVE_SALARY_GENERATE:
      return { ...state, loading: true, success: false };
    case types.SAVE_SALARY_GENERATE_SUCCESS:
      return { ...state, loading: false, success: true, saveSuccess: true, emp_salaryinfo: action.payload.data.emp_salaryinfo, emp_negsalaryinfo: action.payload.data.emp_negativesalary };
    case types.SAVE_SALARY_GENERATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case "CLEAR_APPROVE_ERROR":
      return {
        ...state,
        error: null,
        employeeSalaryDefinition: [],
        employeeSalaryIncrement: [],
        loantype: [],
        loannumber: [],
        installments: [],
        employeeloans: [],
        installment_list: [],
        finacial_types: [],
        employeeSalaryIncrementSavedCTC: [],
        saveIncrementSuccess: false,
        employeeIncrementApprovalCTC: [],
        employeeIncrementReport: [],
        employeefreezelist: [],
        employeepreclose: [],
        employeeloannumber: [],
        employeeloanapplists: [],
        emp_salaryinfo: [],
        emp_negsalaryinfo: [],
        salarygenerate: [],
        salarycale: [],
        salarygeneratelogs: [],
        saveSuccess: false,
      };

    case types.FETCH_SALARY_LOGS:
      return { ...state, loading: true, success: false, saveLoading: true };
    case types.FETCH_SALARY_LOGS_SUCCESS:
      return { ...state, loading: false, success: true, salarygeneratelogs: action.payload, saveLoading: false };
    case types.FETCH_SALARY_LOGS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false, saveLoading: false };
    default:
      return state;
  }
};

export default payrollSalaryEmployeeSalaryDefinitionReducer;
